import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { ApiSchemaBillingInvoices } from "../../models/api";

interface IProps {
  data: ApiSchemaBillingInvoices;
}

Font.register({
  family: "Poppins",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/wfk-poppins@1.0.0/fonts/poppins-regular.ttf",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/wfk-poppins@1.0.0/fonts/poppins-semi-bold.ttf",
    },
  ],
});

export function InvoiceDocument({ data }: IProps) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text>#{data.documentId}</Text>
        <View style={styles.logoWrapper}>
          <Image src="/favicon-tp.png" style={styles.logo} />
        </View>
        <View style={styles.section}>
          <Text style={styles.heading}>Invoice Summary</Text>
          <View style={styles.summary}>
            <View style={styles.summaryRowOne}>
              <View style={styles.summaryRowChild}>
                <Text>Billing cycle: </Text>
                <Text>Invoice date: </Text>
              </View>
              <View style={{ ...styles.summaryRowChild, textAlign: "right" }}>
                <Text>Monthly</Text>
                <Text>{data.billingDate}</Text>
              </View>
            </View>
            <View style={styles.summaryRowTwo}>
              <Text style={styles.rightAlign}>Due on: {data.dueDate}</Text>
            </View>
          </View>
        </View>
        <Text style={styles.heading}>Items in your invoice</Text>
        <View style={styles.section}>
          <View style={styles.table}>
            <View style={styles.tableRow}>
              <View style={{ ...styles.tableCol, width: "40%" }}>
                <Text style={styles.tableHeader}>Item</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableHeader}>Quantity</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableHeader}>Price</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableHeader}>Total</Text>
              </View>
            </View>
            <View style={{ ...styles.tableRow, marginTop: 1 }}>
              <View style={{ ...styles.tableCol, width: "40%" }}>
                <Text style={styles.tableCell}>{data.title}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{data.quantity}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>$ {data.price}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>$ {data.billedAmount}</Text>
              </View>
            </View>
          </View>
        </View>
        <View style={styles.section}>
          <View style={styles.summaryTotal}>
            <Text>Subtotal: $ {data.billedAmount}</Text>
            <Text>Taxes: $ 0.00</Text>
            <Text style={{ fontWeight: "bold" }}>
              Total: $ {data.billedAmount}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}

const styles = StyleSheet.create({
  page: {
    fontSize: 10,
    padding: 30,
    lineHeight: 1.5,
    fontFamily: "Poppins",
  },
  section: {
    marginBottom: 10,
  },
  heading: {
    fontSize: 13,
    fontWeight: "bold",
    marginBottom: 10,
  },
  logoWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 40,
  },
  logo: {
    height: 100,
    width: 100,
  },
  summary: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 70,
  },
  summaryRowOne: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "50%",
  },
  summaryRowChild: {
    width: "50%",
  },
  summaryRowTwo: {
    width: "50%",
  },
  rightAlign: {
    textAlign: "right",
  },
  table: {
    width: "auto",
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    width: "20%",
    borderStyle: "solid",
    borderBottom: 1,
    borderColor: "#dee2e6",
  },
  tableCell: {
    marginTop: 5,
    marginBottom: 5,
  },
  tableHeader: {
    marginTop: 5,
    fontSize: 10,
    marginBottom: 5,
    fontWeight: "bold",
  },
  summaryTotal: {
    textAlign: "right",
    marginTop: 50,
  },
});
